<div class="horizontally-aligned" fxLayout="row" (mousedown)="preventMisclicks($event)">
    <mat-icon class="status-icon" *ngIf="state" [ngClass]="state.cls" [ngStyle]="getIconStyle()"
              [matTooltip]="state.statusDescription" [matTooltipPosition]="tooltipDirection">
        {{ state.icon }}
    </mat-icon>

    <ng-container *ngIf="!hideRecommendedActions">
        <button mat-icon-button class="borderless recommended-action-icon" *ngIf="deviceStatusType !== 2" (click)="showRecommendedActionsPopup($event)">
            <mat-icon [ngStyle]="getIconStyle()" matTooltip="View Recommended Actions" [matTooltipPosition]="tooltipDirection">
                warning
            </mat-icon>
        </button>
    </ng-container>
</div>
